import {Action} from "redux";
import {GetCustomersByPmCampaignPageRequest} from "../request/customer_request";
import {GetCustomersByClientPmCampaignPageResponse} from "../response/customer_response";

export enum ClientPmCampaignActionType {
    REQUEST_GET_CUSTOMERS = "CLIENT_PM_CAMPAIGN_REQUEST_GET_CUSTOMERS",
    CALLBACK_GET_CUSTOMERS = "CLIENT_PM_CAMPAIGN_CALLBACK_GET_CUSTOMERS",
}

export interface IRequestGetCustomerByClientPmCampaignPageAction extends Action {
    type: ClientPmCampaignActionType.REQUEST_GET_CUSTOMERS;
    item: GetCustomersByPmCampaignPageRequest;
}
export interface ICallbackGetCustomerByClientPmCampaignPageAction extends Action {
    type: ClientPmCampaignActionType.CALLBACK_GET_CUSTOMERS;
    isSuccess: boolean;
    item?: GetCustomersByClientPmCampaignPageResponse;
}

export type ClientPmCampaignAction =
    IRequestGetCustomerByClientPmCampaignPageAction |
    ICallbackGetCustomerByClientPmCampaignPageAction;

export interface IClientPmCampaignActionCreator {

    requestGetCustomerByClientPmCampaignPageAction(
        item: GetCustomersByPmCampaignPageRequest
    ): IRequestGetCustomerByClientPmCampaignPageAction;

    callbackGetCustomerByClientPmCampaignPageAction(
        isSuccess: boolean,
        item?: GetCustomersByClientPmCampaignPageResponse,
    ): ICallbackGetCustomerByClientPmCampaignPageAction;

}

class ActionCreator implements IClientPmCampaignActionCreator {

    public requestGetCustomerByClientPmCampaignPageAction = (
        item: GetCustomersByPmCampaignPageRequest
    ): IRequestGetCustomerByClientPmCampaignPageAction => {
        return {
            type: ClientPmCampaignActionType.REQUEST_GET_CUSTOMERS,
            item,
        };
    };

    public callbackGetCustomerByClientPmCampaignPageAction = (
        isSuccess: boolean,
        item?: GetCustomersByClientPmCampaignPageResponse,
    ): ICallbackGetCustomerByClientPmCampaignPageAction => {
        return {
            type: ClientPmCampaignActionType.CALLBACK_GET_CUSTOMERS,
            isSuccess,
            item,
        };
    };

}

export const createClientPmCampaignActionCreator = (): IClientPmCampaignActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_pm_campaign.ts